var portfolioPositionsWeight = {
	caption: "Portfolio positions weight",
	label: {
		name: "Name",
		isin: "ISIN",
		marketValue: "Market value",
		weight: "Weight %",
		weightBar: "Weight % of max"
	},
	noPositions: "No results found"
};
var en = {
	portfolioPositionsWeight: portfolioPositionsWeight
};

export { en as default, portfolioPositionsWeight };
